<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'
  import ListYesNo from '../../../../../app/components/list/YesNo.vue'
  import {clone, cloneDeep} from 'lodash'
  import helpers from '@mixins/helper'
  import {required, requiredIf} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'
  import * as TYPES from '../../../../types'

  export default {
    name: 'event-modalities',
    components: {ListYesNo, ValidationMessage},
    mixins: [helpers],
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        modalPriceVisible: false,
        modalModalityVisible: false,
        isSearchingInstitution: false,
        isResetPrice: false,
        event: {
          id: '',
          event_id: null,
          modalities: []
        },
        modality: {
          event_id: '',
          modality_id: '',
          layout_id: '',
          not_charged: false,
          release_date_certificate: '',
          literacies: [],
          institutions_in: [],
          institutions_not_in: []
        },
        dependencies: {
          literacies: [],
          modalities: [],
          layouts: [],
          institutions: []
        },
        price: {
          event_modality_id: '',
          start_datetime: '',
          end_datetime: '',
          amount: 0
        },
        moneyMask: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          precision: 2,
          masked: false
        }
      }
    },
    mounted () {
      this.getDependencies().then(_ => {
        const id = this.$route.params.id || null
        this.loadData(id)
      })
    },
    validations: {
      modality: {
        modality_id: {required},
        event_id: {required},
        release_date_certificate: {required},
        literacies: {
          required: requiredIf(function () {
            return this.event.event_id
          })
        }
      },
      price: {
        event_modality_id: {required},
        start_datetime: {required},
        end_datetime: {required},
        amount: {required}
      }
    },
    methods: {
      loadData (id) {
        bus.$emit('show-loader')
        if (id) {
          this.isEdit = true
          restfulService.get('event', null, id, null, [
            'modalities.modality',
            'modalities.literacies.literacy',
            'modalities.prices',
            'modalities.currentPrice',
            'modalities.institutions_in',
            'modalities.institutions_not_in'
          ])
            .then(response => {
              this.event.id = response.id
              this.event.event_id = response.event_id
              this.event.modalities = response.modalities
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch(e => {
              console.log(e)
              bus.$emit('hide-loader')
              this.isLoadingData = false
            })
        } else {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        }
      },
      getDependencies () {
        return new Promise((resolve) => {
          DataService.get([{domain: 'modality'}, {domain: 'literacy'}, {domain: 'layout'}]).then((result) => {
            result.modalities.forEach(item => {
              item.disabled = item.key === TYPES.MODALITY_KEY_EVENTO_PRINCIPAL
            })
            this.dependencies = {...this.dependencies, ...result}
            resolve()
          })
        })
      },
      onSearchInstitution (query) {
        if (query !== '') {
          this.isSearchingInstitution = true
          let data = {query}
          restfulService.post('institution', 'search', null, data)
            .then((response) => {
              this.dependencies.institutions.splice(0)
              this.dependencies.institutions = [...this.dependencies.institutions, ...response]
              this.isSearchingInstitution = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      onHandleModalModality () {
        this.modalModalityVisible = !this.modalModalityVisible
      },
      onAddNewModality () {
        this.resetModality()
        this.onHandleModalModality()
      },
      onEditModality (item) {
        const currentModality = cloneDeep(item)
        this.dependencies.institutions.splice(0)
        if (currentModality.institutions_in) {
          currentModality.institutions_in.forEach(item => {
            this.dependencies.institutions.push({
              id: item.institution_id,
              name: item.institution.name
            })
          })
          currentModality.institutions_in = currentModality.institutions_in.map(item => item.institution_id)
        }
        if (this.modality.institutions_not_in) {
          currentModality.institutions_not_in.forEach(item => {
            this.dependencies.institutions.push({
              id: item.institution_id,
              name: item.institution.name
            })
          })
          currentModality.institutions_not_in = currentModality.institutions_not_in.map(item => item.institution_id)
        }
        currentModality.literacies = currentModality.literacies.map(item => item.literacy_id)
        this.modality = currentModality
        this.onHandleModalModality()
      },
      resetModality () {
        this.modality = {
          event_id: this.event.id,
          modality_id: '',
          layout_id: '',
          not_charged: false,
          release_date_certificate: '',
          literacies: [],
          institutions_in: [],
          institutions_not_in: []
        }
        this.$v.modality.$reset()
      },
      onSaveModality () {
        /*
        let modalityId = this.modality.modality_id
        let hasModality = this.event.modalities.some((item) => {
          return item.modality_id === modalityId
        })
        if (!this.modality.id && hasModality) {
          this.$swal({
            title: 'Atenção',
            text: 'Essa modalidade já está cadastrada',
            type: 'warning'
          })
        } else {
        */
        this.isSubmitted = true
        let data = clone(this.modality)
        data.event_id = this.event.id
        data.release_date_certificate = this.dateTimeFormat(data.release_date_certificate, 'en')
        delete data.prices
        delete data.modality
        /*
        if (data.institutions_in.length) {
          data.institutions_in = data.institutions_in.map(item => item.institution_id)
        }
        if (data.institutions_not_in.length) {
          data.institutions_not_in = data.institutions_not_in.map(item => item.institution_id)
        }
        */
        restfulService.save('event_modality', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.onHandleModalModality()
            const id = this.$route.params.id || null
            this.isSubmitted = false
            this.loadData(id)
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
        // }
      },
      onDeleteModality (modality) {
        restfulService.destroy('event_modality', null, modality.id)
          .then(() => {
            notifyService.success({hideLoader: true, message: 'Modalidade removida com sucesso!'})
            this.event.modalities = this.event.modalities.filter((item) => {
              return item.id !== modality.id
            })
          })
          .catch(e => {
            console.log(e)
          })
      },
      onHandleModalPrice (item) {
        this.modality = cloneDeep(item)
        this.price.event_modality_id = item.id
        this.modalPriceVisible = !this.modalPriceVisible
      },
      resetPrice () {
        this.isResetPrice = true
        this.price = {
          event_modality_id: this.modality.id,
          start_datetime: '',
          end_datetime: '',
          amount: 0
        }
        setTimeout(() => {
          this.isResetPrice = false
        }, 100)
        this.$v.price.$reset()
      },
      onSavePrice () {
        let data = clone(this.price)
        data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en')
        data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en')
        data.amount = this.currencyBrToEn(data.amount)
        data.event_modality_id = this.modality.id
        restfulService.post('price', null, null, data)
          .then((response) => {
            notifyService.success({hideLoader: true})
            const currentModality = cloneDeep(this.modality)
            currentModality.prices.push(response)
            this.modality.prices.push(response)
            let modalityIndex = this.event.modalities.map(item => item.id).indexOf(currentModality.id)
            this.event.modalities.splice(modalityIndex, 1, currentModality)
            this.resetPrice()
          })
          .catch(e => {
            console.log(e)
          })
      },
      onDeletePrice (price) {
        restfulService.destroy('price', null, price.id)
          .then(() => {
            notifyService.success({hideLoader: true, message: 'Valor removido com sucesso!'})
            const currentModality = cloneDeep(this.modality)
            currentModality.prices = currentModality.prices.filter((item) => {
              return item.id !== price.id
            })
            let modalityIndex = this.event.modalities.map(item => item.id).indexOf(currentModality.id)
            this.event.modalities.splice(modalityIndex, 1, currentModality)
            this.modality.prices = currentModality.prices.filter((item) => {
              return item.id !== price.id
            })
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <div class="header-flex">
            <h2>Modalidades</h2>
            <el-button type="primary"
                       size="small"
                       v-if="event.event_id"
                       @click="onAddNewModality">
                <i class="fa fa-plus"></i>
                Nova Modalidade
            </el-button>
        </div>
        <table class="custom-table-list">
            <thead>
            <tr>
                <th>Modalidade</th>
                <th>Instituições</th>
                <th>Escolaridades</th>
                <th>Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in event.modalities">
                <td align="center">
                    <div>{{item.modality.name}}</div>
                    <div style="padding-top: 10px;" v-if="item.current_price"><strong>Valor Atual:</strong></div>
                    <div v-if="item.current_price">{{'R$ ' + (item.current_price.amount | currencyEnToBr)}}</div>
                </td>
                <td>
                    <div>
                        <strong>Incluir: </strong>
                        <span v-if="item.institutions_in.length > 0">
                            {{item.institutions_in.map(institution => institution.institution.name).join(', ')}}
                        </span>
                        <span v-if="item.institutions_in.length === 0">Todas</span>
                    </div>
                    <div v-if="item.institutions_not_in.length > 0">
                        <strong>Excluir: </strong>
                        <span>{{item.institutions_not_in.map(institution => institution.institution.name).join(', ')}}</span>
                    </div>
                </td>
                <td>
                    <span v-if="!event.event_id">Todas</span>
                    <span v-else>{{item.literacies.map(modalityLiteracy => modalityLiteracy.literacy.name).join(', ')}}</span>
                </td>
                <td width="150" align="center">
                    <el-button type="default"
                               size="mini"
                               @click="onEditModality(item)"
                               title="Editar Modalidade">
                        <i class="fa fa-edit"></i>
                    </el-button>
                    <el-button type="info"
                               size="mini"
                               v-if="event.event_id"
                               @click="onHandleModalPrice(item)"
                               :disabled="item.not_charged"
                               title="Gerencias Valores">
                        <i class="fa fa-money"></i>
                    </el-button>
                    <el-button type="danger"
                               size="mini"
                               v-if="event.event_id"
                               @click="onDeleteModality(item)"
                               title="Remover Modalidade">
                        <i class="fa fa-times"></i>
                    </el-button>
                </td>
            </tr>
            </tbody>
        </table>

        <el-dialog title="Editando modalidade"
                   top="2vh"
                   :visible.sync="modalModalityVisible">

            <el-form ref="formModality"
                     :model="modality"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="Modalidade"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.modality.modality_id.$error }">
                            <el-select v-model="modality.modality_id"
                                       filterable
                                       clearable
                                       placeholder="Selecione uma modalidade"
                                       empty-text="Nenhum registro encontrado"
                                       :disabled="!!modality.id"
                                       class="el-select-full"
                                       @input="$v.modality.modality_id.$touch()">
                                <el-option
                                        v-for="item in dependencies.modalities"
                                        :key="item.id"
                                        v-show="(!event.event_id && item.disabled) || (event.event_id && !item.disabled)"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <validation-message v-if="$v.modality.modality_id.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="Layout">
                            <el-select v-model="modality.layout_id"
                                       filterable
                                       clearable
                                       placeholder="Selecione um layout"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.layouts"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-show="event.event_id">
                        <el-form-item label="Isento">
                            <el-switch v-model="modality.not_charged"
                                       active-text="SIM"
                                       inactive-text="NÃO">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="Data liberação do certificado"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.modality.release_date_certificate.$error }">
                            <el-date-picker v-model="modality.release_date_certificate"
                                            type="datetime"
                                            format="dd/MM/yyyy HH:mm"
                                            placeholder="Data"
                                            @input="$v.modality.release_date_certificate.$touch()">
                            </el-date-picker>
                            <validation-message
                                    v-if="!$v.modality.release_date_certificate.required && $v.modality.release_date_certificate.$dirty"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-show="event.event_id">
                    <el-col :span="24">
                        <el-form-item label="Incluir Instituições">
                            <el-select v-model="modality.institutions_in"
                                       filterable
                                       multiple
                                       remote
                                       :remote-method="onSearchInstitution"
                                       :loading="isSearchingInstitution"
                                       placeholder="Digite o nome da instituição"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.institutions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-show="event.event_id">
                    <el-col :span="24">
                        <el-form-item label="Excluir Instituições">
                            <el-select v-model="modality.institutions_not_in"
                                       filterable
                                       multiple
                                       remote
                                       :remote-method="onSearchInstitution"
                                       :loading="isSearchingInstitution"
                                       placeholder="Digite o nome da instituição"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.institutions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-show="event.event_id">
                    <el-col :span="24">
                        <el-form-item label="Escolaridades"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.modality.literacies.$error }">
                            <el-transfer class="el-transfer-full"
                                         v-model="modality.literacies"
                                         :data="dependencies.literacies"
                                         :titles="['Disponíveis', 'Selecionadas']"
                                         :props="{
                                              key: 'id',
                                              label: 'name'
                                            }">
                            </el-transfer>
                            <validation-message v-if="$v.modality.literacies.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           @click="onSaveModality"
                           :disabled="isSubmitted || $v.modality.$invalid"
                           type="primary">
                    Salvar Modalidade
                </el-button>
                <el-button @click="onHandleModalModality">Fechar</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Períodos de valores"
                   v-if="modalPriceVisible"
                   :visible.sync="modalPriceVisible">
            <el-form ref="formModalityPrice"
                     :model="price"
                     :inline="true"
                     label-position="top">
                <el-form-item label="Data Início"
                              class="is-required">
                    <el-date-picker
                            v-model="price.start_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data"
                            @input="$v.price.start_datetime.$touch()">
                    </el-date-picker>
                    <validation-message
                            v-if="!$v.price.start_datetime.required && $v.price.start_datetime.$dirty">
                    </validation-message>
                </el-form-item>
                <el-form-item label="Data Término"
                              class="is-required">
                    <el-date-picker
                            v-model="price.end_datetime"
                            type="datetime"
                            format="dd/MM/yyyy HH:mm"
                            placeholder="Data"
                            @input="$v.price.end_datetime.$touch()">
                    </el-date-picker>
                    <validation-message v-if="!$v.price.end_datetime.required && $v.price.end_datetime.$dirty"/>
                </el-form-item>
                <el-form-item label="Valor"
                              class="is-required"
                              v-if="!isResetPrice">
                    <el-input v-model.lazy="price.amount"
                              v-money="moneyMask"
                              @input="$v.price.amount.$touch()">
                    </el-input>
                    <validation-message v-if="!$v.price.amount.required"/>
                </el-form-item>
                <el-form-item>
                    <el-button class="submit"
                               type="primary"
                               @click="onSavePrice"
                               style="margin-top: 24px;"
                               :disabled="isSubmitted || $v.price.$invalid">
                        <i class="fa fa-plus"></i>
                        Gravar Valor
                    </el-button>
                </el-form-item>
            </el-form>
            <table class="custom-table-list">
                <thead>
                <tr>
                    <th>Data Início</th>
                    <th>Data Término</th>
                    <th>Valor</th>
                    <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="priceItem in modality.prices">
                    <td>{{priceItem.start_datetime | dateTimeEnToBr}}</td>
                    <td>{{priceItem.end_datetime | dateTimeEnToBr}}</td>
                    <td>R$ {{priceItem.amount ? (priceItem.amount | currencyEnToBr) : '0,00'}}</td>
                    <td align="center">
                        <el-button type="danger"
                                   title="Remover Valor"
                                   size="mini"
                                   @click="onDeletePrice(priceItem)">
                            <i class="fa fa-times"></i>
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onHandleModalPrice">Fechar</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<style lang="scss">
    .form-new-modality {
        .submit {
            margin-top: 24px;
        }
    }
</style>



// WEBPACK FOOTER //
// Modalities.vue?d514abd8